import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { Col } from "reactstrap";
import { AssistanceUtilitiesWithNavigate } from "../../AssistanceUtilities";
import { useAuth } from "../../context/AuthContext";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import { GetEquipmentDynamicTabIndices } from "../../EquipmentUtilities";
import { EquipmentDTO } from "../../models/Equipment/EquipmentDTO";
import { useNavigateToScheduleCreate } from "../../ScheduleUtilities";
import AssistancesFromEquipment from "../Assistances/AssistancesFromEquipment";
import ButtonComponent from "../ButtonComponent";
import MaintenancePlansFromEquipment from "../MaintenancePlans/MaintenancePlansFromEquipment";
import ProjectsFromEquipment from "../Projects/ProjectsFromEquipment";
import SchedulesFromEquipment from "../Scheduler/SchedulesFromEquipment";
import CountersFromEquipment from "./CountersFromEquipment";
import EquipmentAuditLog from "./EquipmentAuditLog";
import EquipmentCounters from "./EquipmentCounters";

type EquipmentNavBarType = {
    childrenColumnSize?: number;
    equipment: EquipmentDTO | null;
};

export function EquipmentNavBar({ childrenColumnSize = 12, ...props }: EquipmentNavBarType) {
    const intl = useIntl();
    const [activeTab, setActiveTab] = useState<number>(0);
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const assistanceUtilities = AssistanceUtilitiesWithNavigate(navigate);
    const { preferedView } = useAuth();
    const { availableModules } = useAvailableModulesContext();
    const dynamicTabs = GetEquipmentDynamicTabIndices(availableModules, 0);
    const navigateToScheduleCreate = useNavigateToScheduleCreate();

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label={intl.formatMessage({ id: "Screens.Equipment.Navbar.Assistances" })} {...a11yProps(0)} />

                    {dynamicTabs.map((tab: { module: string, index: number }) => {
                        if (tab.module === "ProjectSage50cIsActiveProjectModule") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Equipment.Navbar.Projects" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }
                        if (tab.module === "IsActiveScheduler") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Equipment.Navbar.Schedules" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }
                        if (tab.module === "IsActiveMaintenanceModule") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Equipment.Navbar.MaintenancePlans" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }

                        if (tab.module === "IsActiveCountersModule") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Equipment.Navbar.CountersHistory" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }

                        if (tab.module === "IsActiveEquipmentCountersModule") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Equipment.Navbar.EquipmentCounters" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }

                        return null;
                    })}

                    <Tab label={intl.formatMessage({ id: "Screens.Equipment.Navbar.AuditLog" })} {...a11yProps(dynamicTabs.length + 1)} />

                </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0} childrenColumnSize={childrenColumnSize}>
                <ButtonComponent
                    text={intl.formatMessage({ id: "Screens.Equipment.Navbar.Assistances.CreateA" })}
                    onClick={() => assistanceUtilities.NavigateToAssistanceCreate(id, preferedView)}
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ minHeight: "37px", minWidth: "100px", marginTop: "25px", marginBottom: "25px" }}
                />
                <AssistancesFromEquipment EquipmentErp={id ?? ""} />
            </TabPanel>

            <TabPanel value={activeTab} index={dynamicTabs.length} childrenColumnSize={childrenColumnSize}>
                <EquipmentAuditLog
                    equipmentId={props?.equipment?.id ?? null}
                />
            </TabPanel>

            {dynamicTabs.map((tab: { module: string, index: number }) => {
                if (tab.module === "ProjectSage50cIsActiveProjectModule") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <ProjectsFromEquipment EquipmentErpId={id ?? ""} />
                        </TabPanel>
                    );
                }
                if (tab.module === "IsActiveScheduler") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Screens.Equipment.Navbar.Schedules.Create" })}
                                onClick={() => {
                                    navigateToScheduleCreate(
                                        null,
                                        null,
                                        null,
                                        null,
                                        props.equipment?.client ?? null,
                                        props.equipment ?? null,
                                    );
                                }}
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                style={{ minHeight: "37px", minWidth: "100px", marginTop: "25px", marginBottom: "25px" }}
                            />
                            <SchedulesFromEquipment />
                        </TabPanel>
                    );
                }
                if (tab.module === "IsActiveMaintenanceModule") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <MaintenancePlansFromEquipment
                                client={props?.equipment?.client ?? null}
                                equipment={props?.equipment ?? null}
                            />
                        </TabPanel>
                    );
                }

                if (tab.module === "IsActiveCountersModule") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <CountersFromEquipment equipmentId={props?.equipment?.id ?? 0} />
                        </TabPanel>
                    );
                }

                if (tab.module === "IsActiveEquipmentCountersModule") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <EquipmentCounters equipmentId={props?.equipment?.id ?? 0} />
                        </TabPanel>
                    );
                }
                return null;
            })}
        </>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, childrenColumnSize, ...other } = props;

    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <>{children}</>}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}